import { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { isAdminMaster } from '@/lib/adminConfig';
import { useUserStatus } from '@/hooks/useUserStatus';
import { useToast } from '@/hooks/use-toast';

interface AdminRouteProps {
  children: ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { user, isLoading } = useAuth();
  const { isAdmin: isDbAdmin, isLoading: statusLoading } = useUserStatus(user?.id);
  const { toast } = useToast();
  const allowed = isAdminMaster(user?.email) || isDbAdmin;

  useEffect(() => {
    if (!isLoading && !statusLoading && user && !allowed) {
      toast({
        title: 'Acesso negado',
        description: 'Esta área é restrita ao administrador master.',
        variant: 'destructive',
      });
    }
  }, [isLoading, statusLoading, user, allowed, toast]);

  if (isLoading || statusLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (!allowed) return <Navigate to="/app" replace />;
  return <>{children}</>;
}
